var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenefitIconMobile4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 31,
    viewBox: "0 0 36 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8384_14197)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0176 29.9077C10.0176 25.5434 13.5542 22.001 17.9243 22.001C22.2887 22.001 25.8311 25.5376 25.8311 29.9077H10.0234H10.0176Z",
    stroke: "#187C85",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9265 22.0072C20.4423 22.0072 22.4818 19.9677 22.4818 17.4518C22.4818 14.936 20.4423 12.8965 17.9265 12.8965C15.4106 12.8965 13.3711 14.936 13.3711 17.4518C13.3711 19.9677 15.4106 22.0072 17.9265 22.0072Z",
    stroke: "#187C85",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9346 11.9874C13.4916 10.6098 15.5349 9.77051 17.7749 9.77051C20.0034 9.77051 22.0409 10.5982 23.5921 11.9643",
    stroke: "#187C85",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.392 9.47987C21.7683 8.58764 22.9713 5.93802 22.0791 3.56177C21.1868 1.18553 18.5372 -0.0175107 16.161 0.874716C13.7847 1.76694 12.5817 4.41656 13.4739 6.79281C14.3661 9.16906 17.0158 10.3721 19.392 9.47987Z",
    stroke: "#187C85",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4873 22.1633C24.6507 21.1099 26.1962 20.4731 27.8864 20.4731C31.5156 20.4731 34.4561 23.4136 34.4561 27.0428H27.186",
    stroke: "#187C85",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6716 16.682C31.6716 18.7716 29.9757 20.4675 27.8861 20.4675C25.7965 20.4675 24.1006 18.7716 24.1006 16.682C24.1006 14.5924 25.7965 12.8965 27.8861 12.8965C29.9757 12.8965 31.6716 14.5924 31.6716 16.682Z",
    stroke: "#187C85",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.293 22.1633C11.1295 21.1099 9.58406 20.4731 7.89389 20.4731C4.26465 20.4731 1.32422 23.4136 1.32422 27.0428H8.59427",
    stroke: "#187C85",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.10156 16.682C4.10156 18.7716 5.79752 20.4675 7.88708 20.4675C9.97664 20.4675 11.6726 18.7716 11.6726 16.682C11.6726 14.5924 9.97664 12.8965 7.88708 12.8965C5.79752 12.8965 4.10156 14.5924 4.10156 16.682Z",
    stroke: "#187C85",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8384_14197"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2954,
    height: 30.4867,
    fill: "white",
    transform: "translate(0.739258)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitIconMobile4);
export default __webpack_public_path__ + "static/media/benefit-icon-mobile4.4d9732070febff930a5cb1a3a3623176.svg";
export { ForwardRef as ReactComponent };